import React, { ReactNode } from "react";
import SideBar from "../components/SideBar";
import OliSideBar from "../components/OliSideBar";
import Alert from "../components/Alert";

interface SidebarLayoutProps {
    children: ReactNode;
    isError: boolean;
    error: string | null;
    setIsError: any;
}

const SidebarLayout: React.FC<SidebarLayoutProps> = ({ children, isError, error, setIsError }) => {
    const handleDismiss = (alertId: string) => {
        const alertElement = document.getElementById(alertId);
        if (alertElement) {
            setIsError(false);
            alertElement.style.display = 'none';
        }
    };

    const Oli = (window.location.pathname === "/OliProducts" || window.location.pathname === "/OliProductCustomers/" || window.location.pathname === "/oliCallTracking/" || window.location.href.includes("OliConfigurator") || window.location.pathname === "/Avironix" || window.location.pathname === "/avironixDashboard" || window.location.pathname === "/AvironixDashboard" || window.location.pathname === "/TVSAIChatBot3" )
    
    return (
        <div className="w-full h-full flex">
        {isError &&
            <Alert
                id="alert-2"
                color="red"
                iconColor="text-red-800 dark:text-red-400"
                textColor="text-red-800 dark:text-red-400"
                bgColor="bg-red-50 dark:bg-gray-800"
                onDismiss={() => handleDismiss('alert-2')}
            >
                {error === null ? "Some error happen" : error}
            </Alert>}
            <aside className={` ${!Oli && "w-[60px]"} fixed left-0 top-0 z-50 bottom-0 border-gray-700`} aria-label="Sidebar">
                {
                    !Oli && <SideBar />
                }
            </aside>
            <div className={`w-full h-full ${!Oli && "ml-[62px]"}`}>
                {children}
            </div>
        </div>
    );
}
export default SidebarLayout;